import React, { useEffect, useState, useRef } from "react";
import Breakpoint, {
  BreakpointProvider,
  setDefaultBreakpoints,
} from "react-socks";
import axios from "axios";
import BuyTezPopup from "./BuyTezPopup";
import Slider from "react-slick";
import Clock from "../../components/components/Clock";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getData } from "../../Common/api";
import CustomToastContainer from "../../Common/CustomToastContainer";
import ConnectWalletPopup from "./ConnectWalletPopup";
import TempleWalletPopup from "./TempleWalletPopup";
import { DAppClient, NetworkType } from "@airgap/beacon-sdk";
import { TempleWallet } from "@temple-wallet/dapp";
import { Link, useMatch, useResolvedPath, useNavigate } from "react-router-dom";
import useOnclickOutside from "react-cool-onclickoutside";
import auth from "../../core/auth";
import { io } from "socket.io-client";

// Create a single socket connection
const socket = io(process.env.REACT_APP_SOCKET_SERVER_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});
const generateAvatarurl = process.env.REACT_APP_GENERATE_AVATAR_URL;
const tzktendpoint = process.env.REACT_APP_TZKT_API_ENDPOINT;
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
setDefaultBreakpoints([{ xs: 0 }, { l: 1199 }, { xl: 1200 }]);

const NavLink = (props) => {
  let resolved = useResolvedPath(props.to);
  let match = useMatch({ path: resolved.pathname, end: props.exact || false });

  return <Link {...props} className={match ? "active" : "non-active"} />;
};
const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    { breakpoint: 1900, settings: { slidesToShow: 4, slidesToScroll: 1 } },
    { breakpoint: 1600, settings: { slidesToShow: 4, slidesToScroll: 1 } },
    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, slidesToScroll: 1, dots: true },
    },
  ],
};

const Header = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const modalRef = useRef(null);
  const inputRef = useRef(null);

  const toTez = (mutez) => mutez / 1000000;
  const menuRef = useRef(null);
  const toastRef = useRef();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);
  const [qrCode, setQrCode] = useState(null);
  const [dAppClient, setDAppClient] = useState(null);
  const [userAddress, setUserAddress] = useState();
  const [wallet, setWallet] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [balances, setBalances] = useState({});
  const [showTemplePopup, setShowTemplePopup] = useState(false);
  const [showBalanceDropdown, setshowBalanceDropdown] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [openMenu, setOpenMenu] = React.useState(false);
  const [openMenu1, setOpenMenu1] = React.useState(false);
  const [openMenu2, setOpenMenu2] = React.useState(false);
  const [openMenu3, setOpenMenu3] = React.useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [artResults, setArtResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setloading] = useState(false);
  const handleOpenItem = (nftLink) => {
    setloading(true);

    setTimeout(() => {
      window.open(nftLink, "_self");
      setloading(false);
    }, 1000);
  };
  const shortenAddress = (address) => {
    if (!address) return "";
    return address.slice(0, 5) + "..." + address.slice(-4);
  };
  const [userProfile, setUserProfile] = useState({
    username: "",
    balance: "",
    walletAddress: "",
  });
  useEffect(() => {
    const wallet = localStorage.getItem("walletAddress");
    if (!wallet) return;
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress && storedAddress !== userAddress) {
      setWallet({ pkh: storedAddress });
      generateAvatar(storedAddress);
      fetchBalances(storedAddress);
      setUserAddress(storedAddress);
    }

    // Set walletAddress immediately
    setUserProfile((prev) => ({ ...prev, walletAddress: wallet }));
    setloading(true);
    // Correct: use query parameter ?address=...
    fetch(`${domainpath}/api/profile/basic?address=${wallet}`)
      .then((res) => res.json())
      .then((data) => {
        const profile = data.profile || {};
        setUserProfile((prev) => ({
          ...prev,
          username: profile.username || wallet,
          balance: profile.balance ? `${profile.balance} ꜩ` : "0 ꜩ",
          profileImage:
            profile.profileImage ||
            `${generateAvatarurl}/${wallet}.png?size=200x200`,
        }));
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        console.error("Failed to fetch profile:", err);
      });
  }, []);
  const handleCopy = () => {
    navigator.clipboard.writeText(userProfile.walletAddress).then(() => {
      toastRef.current.addToast(
        "Wallet address copied to clipboard",
        "success"
      );
    });
  };

  // Fetch notifications from API
  const fetchNotifications = async () => {
    try {
      const res = await getData(`/api/notifications`);
      // console.log(res, "res.data");

      setNotifications(res);
      setUnreadCount(res.filter((n) => !n.isRead).length);
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  };

  const authHeader = {
    headers: {
      Authorization: `Bearer ${userAddress}`, // or however you're storing/accessing the wallet address
    },
  };

  // Mark a single notification as read
  const markAsRead = async (id) => {
    try {
      await axios.patch(
        `${domainpath}/api/notifications/${id}/read`,
        {},
        authHeader
      );
      setNotifications((prev) =>
        prev.map((n) => (n._id === id ? { ...n, isRead: true } : n))
      );
      setUnreadCount((prev) => prev - 1);
    } catch (err) {
      console.error("Error marking notification as read:", err);
    }
  };

  // Mark all notifications as read
  const markAllAsRead = async () => {
    try {
      await axios.patch(
        `${domainpath}/api/notifications/read-all`,
        {},
        authHeader
      );
      setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
      setUnreadCount(0);
    } catch (err) {
      console.error("Error marking all as read:", err);
    }
  };

  // Socket listeners for real-time updates
  useEffect(() => {
    if (!socket || !userAddress) return;

    const onNewNotification = (notification) => {
      setNotifications((prev) => [notification, ...prev]);
      setUnreadCount((prev) => prev + 1);
    };

    socket.on("new-notification", onNewNotification);

    // Initial fetch
    fetchNotifications();

    return () => {
      socket.off("new-notification", onNewNotification);
    };
  }, [socket, userAddress]);

  // Get notification icon based on type
  function getNotificationMessage(notification) {
    const { type, metadata = {} } = notification;

    const senderName = metadata.senderName || shortenAddress(metadata.sender);
    const receiverName =
      metadata.receiverName || shortenAddress(metadata.receiver);
    const nftName = metadata.nftName || "your NFT";
    const amount = metadata.amount || metadata.price;

    switch (type) {
      case "makeOffer":
        return `${senderName} made an offer of ${amount} ꜩ on "${nftName}"`;

      case "acceptOffer":
        return `${receiverName} accepted your offer of ${amount} ꜩ for "${nftName}"`;

      case "declineOffer":
        return `${receiverName} declined your offer for "${nftName}"`;

      case "placeBid":
      case "bidActivity":
        return `${senderName} placed a bid of ${amount} ꜩ on "${nftName}"`;

      case "acceptBid":
        return `${receiverName} accepted your bid of ${amount} ꜩ on "${nftName}"`;

      case "outbid":
        return `You’ve been outbid on "${nftName}"`;

      case "auctionEnded":
        return `Auction ended for "${nftName}"`;

      case "itemSold":
        return `Your item "${nftName}" was sold for ${amount} ꜩ`;

      case "successfulPurchase":
        return `You purchased "${nftName}" for ${amount} ꜩ`;

      case "follow":
        return `${senderName} started following you`;

      case "like":
        return `${senderName} liked your art "${nftName}"`;

      default:
        return "You have a new notification.";
    }
  }

  // Format time ago
  const formatTimeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diff = now - date;

    const minutes = Math.floor(diff / (1000 * 60));
    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;

    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  const generateAvatar = (walletAddress) => {
    setProfileImage(`${generateAvatarurl}/${walletAddress}.png?size=200x200`);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setHasSearched(false); // Hide dropdown
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const fetchBalances = async (walletAddress) => {
    try {
      const response = await fetch(
        `${tzktendpoint}/v1/accounts/${walletAddress}`
      );
      const data = await response.json();

      const xtzBalance = (data.balance / 1e6).toFixed(6); // Convert microtez to tez

      // Example Token Balances (You may need to update token contract addresses)
      const tokens = {
        ꜩ: xtzBalance,
        oXTZ: "0.000000", // Fetch from an external API if required
        uUSD: "0.000000",
        USDtz: "0.000000",
        POLE: "0.000000",
      };

      setBalances(tokens);
    } catch (error) {
      console.error("Failed to fetch wallet balances:", error);
    }
  };
  const clearAllIndexedDB = async () => {
    if (window.indexedDB?.databases) {
      const databases = await window.indexedDB.databases();
      await Promise.all(
        databases.map((db) => indexedDB.deleteDatabase(db.name))
      );
    } else {
      console.warn(
        "indexedDB.databases() not supported, falling back to manual deletion"
      );
      await clearBeaconIndexedDB(); // Fallback to Beacon-only deletion
    }
  };
  const clearBeaconIndexedDB = async () => {
    try {
      // Open the Beacon SDK's IndexedDB database
      const dbName = "beacon-sdk-storage";
      const request = indexedDB.deleteDatabase(dbName);

      return new Promise((resolve, reject) => {
        request.onsuccess = () => {
          console.log("Beacon IndexedDB cleared successfully!");
          resolve();
        };

        request.onerror = (event) => {
          console.error("Error clearing Beacon IndexedDB:", event.target.error);
          reject(event.target.error);
        };

        request.onblocked = () => {
          console.warn("IndexedDB deletion blocked (open in another tab?)");
          reject(new Error("IndexedDB deletion blocked"));
        };
      });
    } catch (error) {
      console.error("Failed to clear Beacon IndexedDB:", error);
      throw error;
    }
  };
  const disconnectWallet = async () => {
    try {
      if (dAppClient) {
        // ✅ 1. Clear active account first
        await dAppClient.clearActiveAccount();

        // ✅ 2. Disconnect transport (critical for WebSocket/PostMessage cleanup)
        if (dAppClient._transport) {
          await dAppClient._transport.disconnect();
        }

        // ✅ 3. Clear Beacon SDK's IndexedDB (if supported)
        await clearBeaconIndexedDB();

        // ✅ 4. Destroy the client (optional but recommended)
        await dAppClient.destroy();
      }

      // ✅ 5. Clear all localStorage keys (including Beacon remnants)
      const beaconKeys = Object.keys(localStorage).filter((key) =>
        key.startsWith("beacon:")
      );
      beaconKeys.forEach((key) => localStorage.removeItem(key));
      localStorage.removeItem("walletAddress");
      localStorage.clear();

      // ✅ 6. Clear sessionStorage
      //sessionStorage.clear();

      // ✅ 7. Reset React state
      setWallet(null);
      setQrCode(null);
      window.location.reload();
      // ✅ 8. Force reload if needed (uncomment if issues persist)
      // window.location.reload();

      console.log("✅ Wallet fully disconnected!");
    } catch (error) {
      console.error("🚨 Disconnection error:", error);
    }
  };
  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
  };
  const handleBtnClick2 = () => {
    setOpenMenu2(!openMenu2);
  };
  const handleBtnClick3 = () => {
    setOpenMenu3(!openMenu3);
  };
  const closeMenu = () => {
    setOpenMenu(false);
  };
  const closeMenu1 = () => {
    setOpenMenu1(false);
  };
  const closeMenu2 = () => {
    setOpenMenu2(false);
  };
  const closeMenu3 = () => {
    setOpenMenu3(false);
  };
  const ref = useOnclickOutside(() => {
    closeMenu();
  });
  const ref1 = useOnclickOutside(() => {
    closeMenu1();
  });
  const ref2 = useOnclickOutside(() => {
    closeMenu2();
  });
  const ref3 = useOnclickOutside(() => {
    closeMenu3();
  });

  const [showmenu, btn_icon] = useState(false);
  const [showpop, btn_icon_pop] = useState(false);
  const [shownot, btn_icon_not] = useState(false);
  const closePop = () => {
    btn_icon_pop(false);
  };
  const closeNot = () => {
    btn_icon_not(false);
  };
  const refpop = useOnclickOutside(
    () => {
      closePop();
    },
    {
      ignoreClass: [
        "cursor-pointer",
        "profile-divli",
        "d-wallet", // Wallet info section
        "d-name",
        "de-submenu-profile",
      ], // Add this option
    }
  );
  const refpopnot = useOnclickOutside(() => {
    closeNot();
  });

  const handleLogout = () => {
    auth.clearAppStorage();
    // navigate('/');
  };

  useEffect(() => {
    const headers = document.getElementById("myHeader");
    const totop = document.getElementById("scroll-to-top");
    const sticky = headers.offsetTop;
    const scrollCallBack = window.addEventListener("scroll", () => {
      btn_icon(false);
      if (window.pageYOffset > sticky) {
        headers.classList.add("sticky");
        totop.classList.add("show");
      } else {
        headers.classList.remove("sticky");
        totop.classList.remove("show");
      }
      if (window.pageYOffset > sticky) {
        closeMenu();
      }
    });
    return () => {
      window.removeEventListener("scroll", scrollCallBack);
    };
  }, []);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1199);

  useEffect(() => {
    // Function to check and update screen size
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1199);
    };

    // Check localStorage for saved wallet address
    const savedAddress = localStorage.getItem("walletAddress");
    if (savedAddress) {
      setWallet({ pkh: savedAddress });
    }

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const connectWallet = async () => {
    try {
      const client = new DAppClient({
        name: "My NFT DApp",
        preferredNetwork: NetworkType.GHOSTNET,
      });

      // ✅ Check if user is already connected
      const activeAccount = await client.getActiveAccount();
      if (activeAccount) {
        console.log("Already connected to:", activeAccount.address);
        setWallet({ pkh: activeAccount.address });
        return;
      }

      // ✅ Request wallet permissions
      const permissions = await client.requestPermissions({
        network: { type: NetworkType.GHOSTNET }, // Change to "GHOSTNET" for testnet
      });

      const userAddress = permissions.address;
      setWallet({ pkh: userAddress });
      localStorage.setItem("walletAddress", userAddress);
      setDAppClient(client);
      setQrCode(null); // Hide QR after connection
      setTimeout(() => {
        window.location.reload();
      }, 400);

      console.log("Wallet connected:", userAddress);
    } catch (error) {
      console.error("Temple Wallet Connection Error:", error);
      alert(`Failed to connect: ${error.message}`);
    }
  };
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchQuery.trim()) {
        axios
          .get(
            `${domainpath}/api/art/search?searchKeyword=${searchQuery}&userId=${userAddress}`
          )
          .then((res) => {
            if (res.data.success) {
              setArtResults(res.data.data);
              setHasSearched(true);
              // Directly set the array of art tokens
            }
          })
          .catch((err) => console.error(err));
      } else {
        setArtResults([]);
        setHasSearched(false);
      }
    }, 100); // debounce

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const getMediaType = (mime) => {
    if (!mime) return "Unknown";
    if (mime.startsWith("image/")) {
      return mime.includes("gif") ? "GIF" : "Image";
    }
    if (mime.startsWith("video/")) return "Video";
    if (mime.startsWith("audio/")) return "Audio";
    return "File";
  };
  return (
    <>
      <header id="myHeader" className="navbar white" ref={dropdownRef}>
        <div className="container">
          <div className="row w-100-nav  animaton-custom-menu-style">
            <div className="logo px-0">
              <div className="navbar-title navbar-item">
                <NavLink exact to="/" style={{ cursor: "pointer" }}>
                  <img
                    src="/img/logo-retro.png"
                    className="img-fluid d-block"
                    alt="#"
                  />
                  <img
                    src="/img/logo-retro.png"
                    className="img-fluid d-3"
                    alt="#"
                  />
                  <img
                    src="/img/logo-retro.png"
                    className="img-fluid d-none"
                    alt="#"
                  />
                </NavLink>
              </div>
            </div>

            <div className="search relative" ref={modalRef}>
              <input
                id="quick_search"
                className="xs-hide"
                name="quick_search"
                placeholder="search item here..."
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {hasSearched && artResults.length > 0 && (
                <div className="absolute mt-10 w-full max-h-96 bg-white border border-gray-200 rounded-lg shadow-lg overflow-y-auto z-50">
                  <div className="p-4">
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="text-sm font-semibold text-gray-700">
                        Tokens
                      </h4>
                      <button className="text-sm text-blue-600 hover:underline">
                        view all
                      </button>
                    </div>

                    <ul className="space-y-2">
                      {artResults.map((art) => (
                        <li
                          key={art.id}
                          className="flex items-center gap-3 hover:bg-gray-100 p-2 rounded-lg cursor-pointer"
                        >
                          {art?.blockchain_metadata?.mime_type?.startsWith(
                            "image/"
                          ) ? (
                            <img
                              //fetchpriority="high"
                              decoding="async"
                              // onLoad={onImgLoad}
                              src={art.blockchain_metadata?.ipfs_url?.replace(
                                "ipfs://",
                                "https://ipfs.io/ipfs/"
                              )}
                              className="w-10 h-10 object-cover rounded"
                              alt="NFT"
                              onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop if default image also fails
                                e.target.src = "./img/items/dummy.jpg"; // replace with your actual default image path
                              }}
                            />
                          ) : art?.blockchain_metadata?.mime_type?.startsWith(
                              "video/"
                            ) ? (
                            <video
                              src={art.blockchain_metadata?.ipfs_url?.replace(
                                "ipfs://",
                                "https://ipfs.io/ipfs/"
                              )}
                              // onLoad={onImgLoad}
                              //fetchpriority="high"
                              decoding="async"
                              className="w-10 h-10 object-cover rounded"
                              controls
                            />
                          ) : art?.blockchain_metadata?.mime_type?.startsWith(
                              "audio/"
                            ) ? (
                            <audio
                              src={art.blockchain_metadata?.ipfs_url?.replace(
                                "ipfs://",
                                "https://ipfs.io/ipfs/"
                              )}
                              //fetchpriority="high"
                              decoding="async"
                              className="w-10/12"
                              // onLoad={onImgLoad}
                              style={{ width: "40%", margin: "0 auto" }}
                              controls
                            />
                          ) : (
                            <img
                              // onLoad={onImgLoad}
                              //fetchpriority="high"
                              decoding="async"
                              src="./img/items/dummy.jpg"
                              className="w-10 h-10 object-cover rounded"
                              alt="NFT"
                              // style={{ width: "100%", height: "auto" }}
                            />
                          )}
                          <div>
                            <p className="text-sm font-medium text-gray-800 truncate">
                              {art.title}
                            </p>
                            {console.log(
                              art?.owner?.username,
                              shortenAddress(
                                art?.owner?.address,
                                art?.owner?.address
                              )
                            )}

                            <p className="text-xs text-gray-500 truncate">
                              {art?.owner?.username ||
                                shortenAddress(art?.owner?.address)}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>

            <BreakpointProvider>
              <Breakpoint l down>
                <div
                  className={` animaton-custom-style ${
                    showmenu ? "open" : "close"
                  }`}
                  ref={menuRef}
                >
                  {showmenu && (
                    <div className="menu">
                      <div className="logo px-0">
                        <div className="navbar-title navbar-item">
                          <NavLink exact to="/" style={{ cursor: "pointer" }}>
                            <img
                              src="/img/logo-retro.png"
                              className="img-fluid d-block"
                              alt="#"
                            />
                            <img
                              src="/img/logo-retro.png"
                              className="img-fluid d-3"
                              alt="#"
                            />
                            <img
                              src="/img/logo-retro.png"
                              className="img-fluid d-none"
                              alt="#"
                            />
                          </NavLink>
                        </div>
                      </div>
                      <div className="mobile-menu">
                        <div className="navbar-item">
                          <div ref={ref}>
                            <NavLink
                              exact
                              to="/"
                              onClick={() => btn_icon(!showmenu)}
                            >
                              Home
                            </NavLink>
                          </div>
                        </div>
                        <div className="navbar-item">
                          <div ref={ref1}>
                            <div
                              className="dropdown-custom dropdown-toggle btn background-custom-style"
                              onClick={handleBtnClick1}
                              //   onMouseLeave={closeMenu1}
                            >
                              Drops
                              <span className="lines"></span>
                              {openMenu1 && (
                                <div className="item-dropdown">
                                  <div
                                    className="dropdown"
                                    onClick={closeMenu1}
                                  >
                                    <NavLink
                                      exact
                                      to="/explore/image"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu1();
                                        btn_icon(false);
                                      }}
                                    >
                                      Image
                                    </NavLink>
                                    <NavLink
                                      exact
                                      to="/explore/video"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu1();
                                        btn_icon(false);
                                      }}
                                    >
                                      Video
                                    </NavLink>
                                    <NavLink
                                      exact
                                      to="/explore/gif"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu1();
                                        btn_icon(false);
                                      }}
                                    >
                                      Audio
                                    </NavLink>
                                    <NavLink
                                      exact
                                      to="/explore"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu1();
                                        btn_icon(false);
                                      }}
                                    >
                                      Gif
                                    </NavLink>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="navbar-item">
                          <div ref={ref2}>
                            <div
                              className="dropdown-custom dropdown-toggle btn "
                              onMouseEnter={handleBtnClick2}
                              onMouseLeave={closeMenu2}
                            >
                              Author
                              <span className="lines"></span>
                              {openMenu2 && (
                                <div className="item-dropdown">
                                  <div
                                    className="dropdown"
                                    onClick={closeMenu2}
                                  >
                                    <NavLink
                                      exact
                                      to="/author"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu2();
                                      }}
                                    >
                                      Author
                                    </NavLink>
                                    <NavLink
                                      exact
                                      to="/edit-profile"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu2();
                                      }}
                                    >
                                      Profile
                                    </NavLink>
                                    <NavLink
                                      exact
                                      to="/create"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu2();
                                      }}
                                    >
                                      Create
                                    </NavLink>
                                    {/* <NavLink
                                      exact
                                      to="/blog"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        closeMenu2();
                                      }}
                                    >
                                      Blog
                                    </NavLink> */}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="navbar-item">
                          <NavLink
                            exact
                            to="/activity"
                            onClick={() => btn_icon(!showmenu)}
                          >
                            Activity
                          </NavLink>
                        </div>
                        <div className="navbar-item">
                          <NavLink exact to="/activity">
                            Leaderboard
                            <span className="lines"></span>
                          </NavLink>
                        </div>

                        <div className="navbar-item">
                          <NavLink exact to="/create">
                            Create
                            <span className="lines"></span>
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Breakpoint>

              <Breakpoint xl>
                <div className="menu">
                  <div className="navbar-item">
                    <div ref={ref} style={{ cursor: "pointer" }}>
                      <NavLink exact to="/" onClick={() => btn_icon(!showmenu)}>
                        Home
                      </NavLink>
                    </div>
                  </div>
                  <div className="navbar-item">
                    <div ref={ref1}>
                      <div
                        className="dropdown-custom dropdown-toggle btn "
                        onMouseEnter={handleBtnClick1}
                        onMouseLeave={closeMenu1}
                      >
                        Drops
                        <span className="lines"></span>
                        {openMenu1 && (
                          <div className="item-dropdown">
                            <div className="dropdown" onClick={closeMenu1}>
                              <NavLink
                                exact
                                to="/explore/image"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu1();
                                }}
                              >
                                Image
                              </NavLink>
                              <NavLink
                                exact
                                to="/explore/video"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu1();
                                }}
                              >
                                Video
                              </NavLink>
                              <NavLink
                                exact
                                to="/explore/audio"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu1();
                                }}
                              >
                                Audio
                              </NavLink>
                              <NavLink
                                exact
                                to="/explore/gif"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu1();
                                }}
                              >
                                Gif
                              </NavLink>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="navbar-item">
                    <div ref={ref2}>
                      <div
                        className="dropdown-custom dropdown-toggle btn "
                        onMouseEnter={handleBtnClick2}
                        onMouseLeave={closeMenu2}
                      >
                        Author
                        <span className="lines"></span>
                        {openMenu2 && (
                          <div className="item-dropdown">
                            <div className="dropdown" onClick={closeMenu2}>
                              <NavLink
                                exact
                                to="/author"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu2();
                                }}
                              >
                                Author
                              </NavLink>
                              <NavLink
                                exact
                                to="/edit-profile"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu2();
                                }}
                              >
                                Profile
                              </NavLink>
                              <NavLink
                                exact
                                to="/create"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  closeMenu2();
                                }}
                              >
                                Create
                              </NavLink>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="navbar-item">
                    <NavLink exact to="/activity">
                      Activity
                      <span className="lines"></span>
                    </NavLink>
                  </div>
                  {/* <div className="navbar-item">
                    <NavLink exact to="/activity">
                      Leaderboard
                      <span className="lines"></span>
                    </NavLink>
                  </div>
                  <div className="navbar-item">
                    <NavLink exact to="/blog">
                      Blog
                      <span className="lines"></span>
                    </NavLink>
                  </div> */}
                  <div className="navbar-item">
                    <NavLink exact to="/create">
                      Create
                      <span className="lines"></span>
                    </NavLink>
                  </div>
                </div>
              </Breakpoint>
            </BreakpointProvider>

            <div className="mainside">
              <div
                className="connect-wal connect-wal-wallet-style"
                style={{ position: "relative" }}
              >
                {!wallet ? (
                  isSmallScreen ? (
                    <div
                      className="walletdiv"
                      style={{
                        padding: "10px 15px",
                        borderRadius: "0",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                      onClick={() => connectWallet()}
                    >
                      {/* Wallet Icon */}
                      <svg
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L80 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l368 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                      </svg>
                    </div>
                  ) : (
                    <div className="connectw-div">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 512 512"
                        fill=""
                      >
                        <path d="M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
                      </svg>
                      {/* <a href="/wallet"> */}
                      <p onClick={() => connectWallet()}>Connect Wallet</p>
                      {/* </a> */}
                    </div>
                  )
                ) : isSmallScreen ? (
                  // Mobile: Wallet Icon + Green Tick
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      color: "green",
                      fontWeight: "bold",
                      background: "#000",
                      position: "relative",
                      padding: "6px",
                    }}
                    onClick={disconnectWallet}
                  >
                    {/* Wallet Icon */}
                    <svg
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 512 512"
                    >
                      <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L80 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l368 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                    </svg>
                    {/* Green Tick ✅ */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 448 512"
                      style={{
                        position: "absolute",
                        top: "-7px",
                        left: "17px",
                        background: "#fff",
                        borderRadius: "40px",
                      }}
                    >
                      <path
                        fill="#0b8310"
                        d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                      />
                    </svg>
                  </span>
                ) : (
                  <>
                    <div className="wallet-dropdown">
                      <div
                        id="de-click-menu-notification"
                        className="de-menu-notification"
                        ref={refpopnot}
                      >
                        <div
                          className="d-count"
                          style={{
                            display: unreadCount > 0 ? "block" : "none",
                          }}
                        >
                          {unreadCount > 9 ? "9+" : unreadCount}
                        </div>
                        <i
                          className="fa fa-bell"
                          onClick={() => {
                            btn_icon_not(!shownot);
                            if (!shownot && unreadCount > 0) {
                              markAllAsRead();
                            }
                          }}
                        ></i>

                        {shownot && (
                          <div className="popshow">
                            <div className="de-flex">
                              <h4>Notifications</h4>
                              <span className="viewall">Show all</span>
                            </div>
                            <ul>
                              {console.log(notifications, "notifications")}

                              {notifications.length === 0 ? (
                                <li className="no-notifications">
                                  No notifications yet
                                </li>
                              ) : (
                                notifications
                                  .slice(0, 5)
                                  .map((notification) => (
                                    <>
                                      <li
                                        key={notification._id}
                                        onClick={() =>
                                          markAsRead(notification._id)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          backgroundColor: notification.isRead
                                            ? "transparent"
                                            : "#f5f5f5",
                                        }}
                                      >
                                        <div className="mainnot">
                                          <img
                                            className="lazy"
                                            src={
                                              notification.senderProfileImage ||
                                              "/img/default-avatar.jpg"
                                            } // fallback image
                                            alt=""
                                          />
                                          <div className="d-desc">
                                            <span className="d-name">
                                              <b>
                                                {notification.senderUsername ||
                                                  shortenAddress(
                                                    notification.senderAddress
                                                  )}
                                              </b>{" "}
                                              {getNotificationMessage(
                                                notification
                                              )}
                                            </span>
                                            <span className="d-time">
                                              {formatTimeAgo(
                                                notification.createdAt
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </li>
                                    </>
                                  ))
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                      {/* <div
                        onClick={() => btn_icon_pop(!showpop)}
                        ref={refpop}
                        className="de-click-menu-profile"
                        style={{ background: "#000", padding: "5px 10px " }}
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 512 512"
                        >
                          <path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L80 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l368 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                        </svg>
                      </div> */}
                      <img
                        src={userProfile?.profileImage}
                        alt="Profile"
                        className="avatar"
                        onClick={() => btn_icon_pop(!showpop)}
                        ref={refpop}
                      />
                      {showpop && (
                        <div className="popshow">
                          <div
                            id="de-submenu-profile"
                            className="de-submenu open"
                            style={{ backgroundSize: "cover" }}
                          >
                            <div
                              className="d-name"
                              style={{ backgroundSize: "cover" }}
                            >
                              <h4>{userProfile.username}</h4>
                              <div
                                className="cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setShowPopup(false); // Close popup first
                                  setTimeout(
                                    () => navigate("/edit-profile"),
                                    100
                                  ); // Small delay
                                }}
                              >
                                Set display name
                              </div>
                            </div>

                            <div
                              className="spacer-10"
                              style={{ backgroundSize: "cover" }}
                            ></div>

                            <div
                              className="d-balance"
                              style={{ backgroundSize: "cover" }}
                            >
                              <h4>Balance</h4>
                              {userProfile.balance}
                            </div>

                            <div
                              className="spacer-10"
                              style={{ backgroundSize: "cover" }}
                            ></div>

                            <div
                              className="d-wallet"
                              style={{ backgroundSize: "cover" }}
                            >
                              <h4>My Wallet</h4>
                              <span id="wallet" className="d-wallet-address">
                                {shortenAddress(userProfile.walletAddress)}
                              </span>
                              <button
                                id="btn_copy"
                                title="Copy Text"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  try {
                                    await handleCopy(); // Make sure handleCopy is async/returns a promise
                                    // Optional: Show feedback without closing popup
                                  } catch (error) {
                                    console.error("Copy failed:", error);
                                  }
                                  // Don't close popup on copy - better UX
                                }}
                              >
                                Copy
                              </button>
                            </div>

                            <div
                              className="d-line"
                              style={{ backgroundSize: "cover" }}
                            ></div>

                            <ul className="de-submenu-profile">
                              <li
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent event bubbling
                                  navigate("/author");
                                  setShowPopup(false); // Close the popup
                                }}
                              >
                                <div className="profile-divli">
                                  <i className="fa fa-user"></i> My profile
                                </div>
                              </li>
                              <li
                                className="profile-divli"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/edit-profile");
                                  setShowPopup(false);
                                }}
                              >
                                <div>
                                  <i className="fa fa-pencil"></i> Edit profile
                                </div>
                              </li>
                              <li
                                className="profile-divli"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  disconnectWallet();
                                  setShowPopup(false);
                                }}
                              >
                                <div>
                                  <i className="fa fa-sign-out"></i> Sign out
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                      {showBalanceDropdown && (
                        <div className="wallet-balances">
                          <p>
                            ꜩ <span className="wallet-balancesspan"></span>
                            <span>{balances.ꜩ || "0.000000"}</span>
                          </p>
                          <p>
                            oXTZ <span className="wallet-balancesspan"></span>
                            <span>{balances.oXTZ || "0.000000"}</span>
                          </p>
                          <p>
                            uUSD <span className="wallet-balancesspan"></span>
                            <span>{balances.uUSD}</span>
                          </p>
                          <p>
                            USDtz<span className="wallet-balancesspan"></span>{" "}
                            <span>{balances.USDtz}</span>
                          </p>
                          <p>
                            POLE <span className="wallet-balancesspan"></span>
                            <span>{balances.POLE}</span>
                          </p>
                          <div className="button-group">
                            <button
                              className="exchange-btn"
                              onClick={() => navigate("/exchange")}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                width="18"
                                height="18"
                              >
                                <path d="M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z" />
                              </svg>{" "}
                              Exchange
                            </button>
                            <button
                              className="topup-btn"
                              onClick={() => setPopupOpen(true)}
                            >
                              <svg
                                width="18"
                                height="18"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="rgb(1, 144, 90)"
                              >
                                <path d="M320 96L192 96 144.6 24.9C137.5 14.2 145.1 0 157.9 0L354.1 0c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128l128 0c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4c0 0 0 0 0 0s0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z" />
                              </svg>{" "}
                              Top Up
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="logout">
                <NavLink exact to="/createOptions">
                  Create
                </NavLink>
                <div
                  id="de-click-menu-notification"
                  className="de-menu-notification"
                  onClick={() => btn_icon_not(!shownot)}
                  ref={refpopnot}
                >
                  <div className="d-count">8</div>
                  <i className="fa fa-bell"></i>
                  {shownot && (
                    <div className="popshow">
                      <div className="de-flex">
                        <h4>Notifications</h4>
                        <span className="viewaall">Show all</span>
                      </div>
                      <ul>
                        <li>
                          <div className="mainnot">
                            <img
                              className="lazy"
                              src="../../img/author/author-2.jpg"
                              alt=""
                            />
                            <div className="d-desc">
                              <span className="d-name">
                                <b>Mamie Barnett</b> started following you
                              </span>
                              <span className="d-time">1 hour ago</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="mainnot">
                            <img
                              className="lazy"
                              src="../../img/author/author-3.jpg"
                              alt=""
                            />
                            <div className="d-desc">
                              <span className="d-name">
                                <b>Nicholas Daniels</b> liked your item
                              </span>
                              <span className="d-time">2 hours ago</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="mainnot">
                            <img
                              className="lazy"
                              src="../../img/author/author-4.jpg"
                              alt=""
                            />
                            <div className="d-desc">
                              <span className="d-name">
                                <b>Lori Hart</b> started following you
                              </span>
                              <span className="d-time">18 hours ago</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="mainnot">
                            <img
                              className="lazy"
                              src="../../img/author/author-5.jpg"
                              alt=""
                            />
                            <div className="d-desc">
                              <span className="d-name">
                                <b>Jimmy Wright</b> liked your item
                              </span>
                              <span className="d-time">1 day ago</span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="mainnot">
                            <img
                              className="lazy"
                              src="../../img/author/author-6.jpg"
                              alt=""
                            />
                            <div className="d-desc">
                              <span className="d-name">
                                <b>Karla Sharp</b> started following you
                              </span>
                              <span className="d-time">3 days ago</span>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <button className="nav-icon" onClick={() => btn_icon(!showmenu)}>
            <div className="menu-line white"></div>
            <div className="menu-line1 white"></div>
            <div className="menu-line2 white"></div>
          </button>
        </div>
      </header>
      <ConnectWalletPopup
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        setShowTemplePopup={setShowTemplePopup}
      />
      <TempleWalletPopup
        showTemplePopup={showTemplePopup}
        setShowTemplePopup={setShowTemplePopup}
        connectWallet={connectWallet}
        qrCode={qrCode}
        walletAddress={wallet ? wallet.pkh : null}
      />
      <BuyTezPopup isOpen={isPopupOpen} onClose={() => setPopupOpen(false)} />

      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
      <CustomToastContainer ref={toastRef} />
    </>
  );
};
export default Header;
